import {
  JobAgeHighlightMapping,
  RemoteHighlightMapping,
} from '@/components/job-posting/contexts/job-posting-tracking-context/constants';

import { useHeaderContext } from '../../context';

export const useHighlightsTrackingData = (): string => {
  const { isVerifiedByXing, remoteOptionKey, isApplyWithoutDocuments, matchingJobAgeKey, isMatchingSalary, salary } =
    useHeaderContext();

  const result = [
    isMatchingSalary && salary && 'job_tag_salary',
    remoteOptionKey && RemoteHighlightMapping[remoteOptionKey],
    isApplyWithoutDocuments && 'job_tag_instant_apply',
    matchingJobAgeKey && JobAgeHighlightMapping[matchingJobAgeKey],
    isVerifiedByXing && 'job_tag_xing_verified',
  ].filter(Boolean); // Removes undefined values

  return result.length > 0 ? result.join(',') : 'job_tag_none';
};
